module.exports = __webpack_public_path__ + "img/loading_blue.88599dc1.gif";